<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 财务管理 / 发放明细</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:0 15px;">
      <div @click="addAdmin" class="addBtn">返回投资</div>
    </div>
    <div style="padding: 10px 15px">
      <div>
        <table width="100%">
          <tr>
            <th class="th">
              发放ID
            </th>
            <th class="th">
              发放日期
            </th>
            <th class="th">
              币种
            </th>
            <th class="th">
              本金
            </th>
            <th class="th">
              利息
            </th>
            <th class="th">
              其他金额
            </th>
            <th class="th">用户ID</th>
            <th class="th">发放状态</th>
            <th class="th">发放时间</th>
            <th class="th">生成时间</th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              {{ value.issueId }}
            </td>
            <td class="td">
              {{ value.issueDay }}
            </td>
            <td class="td">
              {{ value.issueCurrency }}
            </td>
            <td class="td">
              {{ value.issuePrice }}
            </td>
            <td class="td">
              {{ value.issueInterest }}
            </td>
            <td class="td">{{ value.issueOtherPrice }}</td>
            <td class="td">{{ value.issueUser }}</td>
            <td class="td">{{ value.issueState==0?'未发放':'已发放' }}</td>
            <td class="td">{{ value.issueSendTime }}</td>
            <td class="td">{{ value.issueTime }}</td>
          </tr>
        </table>
      </div>

    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "IssueListByInvestId",
  data(){
    return{
      adminList:[],
      page:1,
      num:20,
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
  },
  methods: {
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.$emit("send",'updateLevel')
    },
    deleteAdmin(id){
      if(confirm("确认删除此等级吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"api/DeleteLevel?id="+id,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    addAdmin(){
      this.$emit("send",'investList')
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"invest/GetIssueByInvestId?investId="+localStorage.getItem("UPDATEOBJ"),function (res){
        console.log(res.data)
        closeLoading()
        that.adminList=res.data
      })
    },
  }
}
</script>

<style scoped>
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>